// extracted by css-extract-rspack-plugin
export default {"noScroll":"_8715dfd7","body":"_6f17eb0b","aboveOverlay":"_f0f932be","menu":"_5fb67968 _6f17eb0b","includePadding":"_71691096","transparent":"_7633e6fd"};